import { render, staticRenderFns } from "./ReceptionDetailProjectTeamEditor.vue?vue&type=template&id=209d66f6&scoped=true&"
import script from "./ReceptionDetailProjectTeamEditor.vue?vue&type=script&lang=ts&"
export * from "./ReceptionDetailProjectTeamEditor.vue?vue&type=script&lang=ts&"
import style0 from "./ReceptionDetailProjectTeamEditor.vue?vue&type=style&index=0&id=209d66f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "209d66f6",
  null
  
)

export default component.exports